export default "__VITE_ASSET__nAlm7axr__"